export default __webpack_public_path__ + "aa07a4a6fb070ea19e43b1462c1bb717.png";